// =============================================================================
// Counter Animation
// =============================================================================
export function initCounters() {

    function animateCounter(el) {
        const target   = parseFloat(el.dataset.counter);
        const suffix   = el.dataset.counterSuffix || '';
        const prefix   = el.dataset.counterPrefix || '';
        const decimals = el.dataset.counterDecimals ? parseInt(el.dataset.counterDecimals) : 0;
        const duration = 1800; // ms
        const start    = performance.now();

        function step(now) {
            const elapsed  = now - start;
            const progress = Math.min(elapsed / duration, 1);
            // Ease out cubic
            const eased    = 1 - Math.pow(1 - progress, 3);
            const value    = eased * target;

            el.textContent = prefix + value.toFixed(decimals).replace('.', ',') + suffix;

            if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }

    function checkInview(el) {
        if (!el.classList) return;
        if (el.classList.contains('inView')) {
            el.querySelectorAll('[data-counter]').forEach(animateCounter);
        }
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes') {
                checkInview(mutation.target);
            } else if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) return;
                    checkInview(node);
                    node.querySelectorAll('.inView').forEach(checkInview);
                });
            }
        });
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
    });

    // Bereits vorhandene .inView-Elemente beim Init prüfen
    document.querySelectorAll('.inView').forEach(checkInview);
}